import SelectKeywordCategories from './SelectKeywordCategories';
import './SelectKeywordCategories.scss';

export default SelectKeywordCategories;